import React, { Component } from 'react';
import _ from 'lodash';

export default class FlashCardActions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            multichoiceRight: true
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.card?.model === 'multichoice' && this.props.isFlipped !== prevProps.isFlipped && this.props.isFlipped) {
            const correctAnswer = this.props.card.multi_choice_answer;
            const correctChoiceEl = document.getElementById(`choice-${correctAnswer}`);
            const checkedChoiceEl = document.querySelector('input[name="multichoice"]:checked')?.parentElement;
            if (correctChoiceEl && checkedChoiceEl) {
                this.setState({ multichoiceRight: correctChoiceEl === checkedChoiceEl });
            }
        }
    }

    renderActions() {
        const isLoading = _.isEmpty(this.props.card);
        const frontSideActions = (
            <>
                <div className="button-bar_items_item">
                    <button className="button button--reveal" onClick={() => !isLoading && this.props.flipCard()}>Reveal Answer</button>
                    <div className='button-bar_items_item_hint spacebar-hint'>SPACEBAR</div>
                </div>
            </>
        );
        let backSideActions = (
            <>
                <div className="button-bar_items_item">
                    <button data-answer="hard" className="button button--rating button--wrong" onClick={() => this.props.handleResponse('hard')}>Wrong</button>
                    <div className='button-bar_items_item_hint'>10m</div>
                </div>
                <div className="button-bar_items_item">
                    <button data-answer="right" className="button button--rating button--right" onClick={() => this.props.handleResponse('right')}>Right</button>
                    <div className='button-bar_items_item_hint'>1d</div>
                </div>
                <div className="button-bar_items_item">
                    <button data-answer="easy" className="button button--rating button--easy" onClick={() => this.props.handleResponse('easy')}>Easy</button>
                    <div className='button-bar_items_item_hint'>3d</div>
                </div>
            </>
        );
        if (this.props.card?.model === 'multichoice') {
            backSideActions = (
                <>
                    <div className="button-bar_items_item">
                        <button className="button button--rating button--right" onClick={() => this.props.handleResponse(this.state.multichoiceRight ? 'right' : 'hard')}>Next</button>
                    </div>
                </>
            )
        }
        return this.props.isFlipped ? backSideActions : frontSideActions;
    }

    render() {
        return (
            <React.Fragment>
                <div className={`button-bar button-bar--3-options ${this.props.isFlipped ? 'button-bar--assess' : ''} ${this.props.card?.model === 'multichoice' ? 'button-bar--multichoice' : ''}`}>
                    <div className="button-bar__label">ASSESS YOUR KNOWLEDGE</div>
                    <div className="button-bar_items">
                        {this.renderActions()}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
